import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let stepUpHandler = null;
export const setStepUpHandler = (fn) => { stepUpHandler = fn; };

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/") && localStorage.getItem("session_token")) {
      localStorage.removeItem("session_token");
      window.dispatchEvent(new CustomEvent("session-expired", { detail: err.response?.data?.detail }));
    }
    if (status === 428 && stepUpHandler && !err.config.__stepUpRetried) {
      const ok = await stepUpHandler();
      if (ok) return api({ ...err.config, __stepUpRetried: true });
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Terjadi kesalahan") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};

export default api;
